import { hasRole } from "@data/utility/ability"
import { useMemo } from "react"
import { getTrackRefId } from "@common/livekit/liveKitUtils"

export const isolatedRoomTypes = [
    'biweekly',
    'study_group',
    // 'individual',
    'holiday_course',
    'holiday_workbook',
    'trial',
    'support',
    'custom',
]

export const useFilteredTracks = (
    tracks,
    currentUser,
    participants,
    liveSession
) => {
    // Stable key over the tracks array — recomputes only when the set of
    // track IDs changes (not on every render).
    const tracksKey = useMemo(
        () => tracks?.reduce((acc, x) => acc + getTrackRefId(x), "") ?? "",
        [tracks]
    )

    const roomType = liveSession?.live_room?.type
    const currentUserId = currentUser?.id

    return useMemo(() => {
        if (
            hasRole(currentUser, "student") &&
            isolatedRoomTypes.includes(roomType)
        ) {
            return tracks.filter((track) => {
                const participantUserId =
                    track?.participant?.identity?.split(".")[0]
                const participantUser = participants?.find(
                    (p) => p?.id?.toString() === participantUserId
                )

                // Show tracks from tutor or current student
                return (
                    participantUser?.is_tutor ||
                    participantUserId === currentUserId?.toString()
                )
            })
        }

        return tracks
        // tracksKey replaces the inline reduce so we still skip identical
        // tracks arrays; the external reads (currentUser/participants/roomType)
        // are now part of the dep array so the filter re-runs when they change.
    }, [tracksKey, currentUserId, participants, roomType])
}
